import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import { makeStyles, Theme } from "@material-ui/core/styles";
import { IconButton } from "@material-ui/core";
import ClearIcon from "@material-ui/icons/Clear";

const useStyles = makeStyles((theme: Theme) => ({
  backdrop: {
    backgroundColor: "rgba(0, 0, 0, 0.5)",
  },
  paper: {
    backgroundColor: "transparent",
    boxShadow: "none",
    overflow: "visible",
  },
  content: {
    backgroundColor: "#e8f4fd",
    minWidth: 420,
    padding: "20px 24px",
    textAlign: "center",
    borderRadius: "4px 4px 0 0",
  },
  closeIcon: {
    position: "absolute",
    top: 1,
    right: 1,
  },
  icon: {
    fontSize: 22,
    verticalAlign: "middle",
    marginRight: 8,
    marginBottom: 6,
    color: theme.palette.info.main,
  },
  title: {
    fontWeight: 400,
    marginBottom: 8,
  },
  subtitle: {
    color: theme.palette.text.secondary,
    fontSize: 12,
  },
  actions: {
    backgroundColor: "#e8f4fd",
    justifyContent: "center",
    padding: "0 24px 16px",
    gap: 12,
    borderRadius: "0 0 4px 4px",
  },
}));

export type DistanceMismatchDialogProps = {
  open: boolean;
  distance: number;
  onConfirm(): void;
  onCancel(): void;
};

function DistanceMismatchDialog(props: DistanceMismatchDialogProps) {
  const { open, distance, onConfirm, onCancel } = props;
  const classes = useStyles();

  return (
    <Dialog
      open={open}
      onClose={onCancel}
      disableBackdropClick
      disableEscapeKeyDown
      BackdropProps={{
        className: classes.backdrop,
      }}
      PaperProps={{
        className: classes.paper,
      }}
    >
      <DialogContent className={classes.content}>
        <IconButton
          className={classes.closeIcon}
          onClick={onCancel}
          aria-label="Fermer"
        >
          <ClearIcon style={{ fontSize: 18 }} />
        </IconButton>
        <Typography className={classes.title}>
          <InfoOutlinedIcon className={classes.icon} />
          Un écart de distance a été détecté ({Math.round(distance)} m)
        </Typography>
        <Typography className={classes.subtitle}>
          Êtes-vous sûr de vouloir valider le FPS avec cette adresse ?
        </Typography>
      </DialogContent>
      <DialogActions className={classes.actions}>
        <Button size="small" variant="contained" onClick={onCancel}>
          NON
        </Button>
        <Button
          color="primary"
          size="small"
          variant="contained"
          onClick={onConfirm}
        >
          OUI
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default DistanceMismatchDialog;
